import React from 'react';

// SVG Logo from user's provided file - text as paths
export const SplaLogo = ({ className = "", size = "default" }) => {
  const sizeMap = {
    small: 28,
    default: 48,
    large: 80,
    xlarge: 100
  };

  const height = sizeMap[size];
  const width = height * 2.13;

  return (
    <svg 
      className={className}
      width={width}
      height={height}
      viewBox="0 0 1063.8 500" 
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      {/* Text "Splav" as paths */}
      <g>
        <path d="M503.2,206.3c-0.7-6.8-3.8-12.1-9.1-15.9c-5.4-3.8-12.3-5.7-20.9-5.7c-6,0-11.2,0.9-15.5,2.7c-4.3,1.8-7.6,4.3-9.9,7.4
          c-2.3,3.1-3.4,6.7-3.5,10.7c0,3.3,0.8,6.2,2.3,8.6c1.5,2.4,3.6,4.5,6.3,6.2c2.6,1.7,5.6,3.1,8.8,4.2s6.5,2.1,9.7,2.9l14.9,3.7
          c6,1.4,11.8,3.3,17.4,5.7c5.6,2.4,10.6,5.4,15,9c4.4,3.6,7.9,8,10.5,13.1s3.9,11.1,3.9,18c0,9.3-2.4,17.5-7.2,24.6
          c-4.8,7.1-11.6,12.6-20.6,16.6c-9,4-19.9,5.9-32.6,5.9c-12.4,0-23.1-1.9-32.2-5.8c-9.1-3.8-16.2-9.4-21.3-16.8
          c-5.1-7.4-7.9-16.3-8.3-26.9h28.4c0.4,5.5,2.1,10.2,5.1,13.8c3,3.7,6.9,6.4,11.8,8.2c4.8,1.8,10.3,2.7,16.3,2.7
          c6.3,0,11.8-0.9,16.5-2.8c4.7-1.9,8.5-4.5,11.2-7.9c2.7-3.4,4.1-7.4,4.1-11.9c-0.1-4.1-1.3-7.6-3.7-10.3c-2.4-2.7-5.7-5-10-6.8
          c-4.3-1.8-9.3-3.5-15-4.9l-18.1-4.7c-13.1-3.4-23.5-8.5-31-15.4c-7.6-6.9-11.4-16-11.4-27.4c0-9.4,2.6-17.6,7.7-24.7
          s12.1-12.5,20.9-16.4c8.8-3.9,18.8-5.9,29.9-5.9c11.3,0,21.2,2,29.7,5.9c8.5,3.9,15.2,9.3,20.1,16.3c4.9,6.9,7.4,14.9,7.5,23.8
          H503.2z"/>
        <path d="M551,366.6V202.3h27.7v19.8h1.6c1.5-2.9,3.5-6,6.1-9.3c2.6-3.3,6.2-6.1,10.7-8.5c4.5-2.4,10.3-3.5,17.3-3.5
          c9.2,0,17.6,2.3,25,7c7.4,4.7,13.3,11.6,17.7,20.8c4.4,9.2,6.6,20.4,6.6,33.6c0,13.1-2.2,24.3-6.5,33.4s-10.2,16.2-17.6,21
          c-7.4,4.8-15.8,7.2-25.2,7.2c-6.8,0-12.5-1.1-17-3.4c-4.5-2.3-8.1-5-10.8-8.3c-2.7-3.2-4.8-6.3-6.3-9.2h-1.2v63.6H551z
           M578.6,262.1c0,7.7,1.1,14.5,3.3,20.3c2.2,5.8,5.4,10.3,9.6,13.6c4.2,3.2,9.2,4.9,15.2,4.9c6.2,0,11.4-1.7,15.6-5
          c4.2-3.3,7.4-7.9,9.5-13.8c2.1-5.8,3.2-12.5,3.2-19.9c0-7.4-1.1-14-3.2-19.8c-2.1-5.8-5.3-10.3-9.5-13.5s-9.4-4.9-15.7-4.9
          c-6,0-11.1,1.6-15.3,4.7c-4.2,3.2-7.4,7.6-9.5,13.3C579.7,247.6,578.6,254.3,578.6,262.1z"/>
        <path d="M709.3,162.5v159.3h-28.1V162.5H709.3z"/>
        <path d="M766,324.2c-7.6,0-14.4-1.4-20.4-4.1s-10.8-6.8-14.3-12.1c-3.5-5.3-5.2-11.9-5.2-19.8c0-6.7,1.2-12.3,3.7-16.7
          c2.5-4.4,5.9-7.9,10.2-10.6c4.3-2.6,9.2-4.7,14.6-6c5.4-1.4,11-2.4,16.8-3c7-0.7,12.7-1.4,17-2c4.4-0.6,7.5-1.5,9.5-2.8
          c2-1.3,3-3.3,3-5.9v-0.5c0-5.9-1.7-10.4-5.2-13.6c-3.5-3.2-8.5-4.8-15-4.8c-6.9,0-12.3,1.5-16.4,4.5c-4,3-6.7,6.6-8.1,10.7
          l-26.3-3.7c2.1-7.3,5.5-13.3,10.3-18.2c4.8-4.9,10.6-8.6,17.5-11c6.9-2.5,14.5-3.7,22.9-3.7c5.8,0,11.5,0.7,17.2,2
          c5.7,1.3,10.9,3.6,15.6,6.6c4.7,3.1,8.5,7.3,11.4,12.6c2.9,5.3,4.3,11.9,4.3,19.8v79.9h-27v-16.4H801c-1.7,3.3-4.1,6.4-7.2,9.3
          c-3.1,2.9-6.9,5.2-11.6,6.9C777.6,323.3,772.2,324.2,766,324.2z M773.3,303.5c5.6,0,10.5-1.1,14.7-3.4c4.1-2.3,7.3-5.2,9.6-9
          c2.3-3.7,3.4-7.8,3.4-12.2v-14.1c-0.9,0.7-2.4,1.4-4.5,2s-4.4,1.2-7,1.6c-2.6,0.5-5.2,0.9-7.7,1.2c-2.5,0.4-4.7,0.7-6.6,0.9
          c-4.2,0.6-8,1.5-11.3,2.8c-3.3,1.3-5.9,3.1-7.8,5.4c-1.9,2.3-2.9,5.3-2.9,8.9c0,5.2,1.9,9.1,5.7,11.7S767.4,303.5,773.3,303.5z"/>
        <path d="M953.1,202.3l-42.5,119.5h-31.1L837,202.3h30l27.4,88.7h1.2l27.5-88.7H953.1z"/>
      </g>
      {/* Logo icon - two overlapping parallelograms */}
      <path d="M165.2,284.2c-2.2-8.6-4.2-16.5-6.2-24.5c-1.6-6.5-3.4-13-4.7-19.5c-1.7-8-0.2-15.1,5.4-21.5c7.7-8.8,15-17.9,22.5-26.9
        c5-6,10.2-11.9,15.2-17.9c6.3-7.5,12.4-15,18.7-22.5c5.1-6.1,10.4-12,15.4-18.2c3.2-4,6.7-7.6,11.6-9.3c2.3-0.8,4.8-1.3,7.2-1.4
        c32.5-0.1,65.1-0.1,97.6,0c10.4,0,19.9,9.2,20.2,20c0.2,7.4-2.8,13.1-7.5,18.4c-6.2,7.1-12,14.5-18.1,21.7c-5,5.9-10,11.8-15,17.7
        c-3.2,3.8-6.2,7.7-9.5,11.3c-4.2,4.7-9.2,7.8-15.9,7.9c-13.2,0.3-26.4,0.8-39.6,1.3c-5.4,0.2-10.8,0.3-16.2,0.7
        c-8.5,0.5-16.9,1.1-25.4,2c-4.7,0.5-8.2,3.6-11.2,7c-7.8,9.1-15.4,18.4-23.1,27.6C179.5,266.8,172.6,275.3,165.2,284.2z"/>
      <path d="M335.9,200.7c1.8,6.9,3.5,13.3,5.1,19.7c2,8.3,3.9,16.5,6,24.8c1.9,7.8-0.3,14.5-5.3,20.5c-7.7,9.2-15.4,18.4-23.1,27.6
        c-5,6-10.2,11.9-15.2,17.9c-6.3,7.5-12.4,15-18.7,22.5c-5.2,6.2-10.6,12.1-15.6,18.4c-3.7,4.7-7.9,8.3-14,9.3
        c-1.1,0.2-2.1,0.4-3.2,0.4c-33,0-65.9,0-98.9,0c-9.1,0-18.5-8.8-19.6-17.9c-1.1-8.4,2.3-14.5,7.5-20.4c6.1-7,11.8-14.4,17.8-21.6
        c4.9-5.9,9.9-11.6,14.8-17.4c6.4-7.6,12.6-15.5,19.2-22.9c4.6-5.3,8.5-11.6,16-13.5c2.2-0.5,4.4-0.9,6.6-1
        c8.1-0.3,16.2-0.5,24.4-0.7c5.6-0.2,11.2-0.4,16.8-0.6c11.1-0.4,22.2-0.8,33.4-1.3c7.6-0.4,13.3-4.3,17.9-10
        c5-6.1,10.1-12.2,15.2-18.3C327,211.1,331.3,206.1,335.9,200.7z"/>
    </svg>
  );
};

// Icon only version (for favicon, small uses)
export const SplaIcon = ({ className = "", size = 40 }) => {
  return (
    <svg 
      className={className}
      width={size}
      height={size}
      viewBox="0 0 500 500" 
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
    >
      <path d="M111.5,314.3c-3.3-13.1-6.5-25.3-9.5-37.5c-2.5-9.9-5.1-19.9-7.2-29.9c-2.5-12.2-0.4-23.2,8.2-33
        c11.8-13.4,22.9-27.5,34.4-41.2c7.7-9.2,15.6-18.2,23.3-27.4c9.6-11.4,19-23,28.6-34.5c7.8-9.3,16-18.3,23.6-27.8
        c4.9-6.1,10.2-11.6,17.7-14.2c3.5-1.2,7.3-2.1,11-2.1c49.8-0.1,99.6-0.2,149.5,0c15.9,0.1,30.5,14.1,30.9,30.7
        c0.3,11.4-4.4,20-11.6,28.2c-9.5,10.8-18.4,22.2-27.7,33.3c-7.6,9.1-15.3,18.1-22.9,27.1c-4.9,5.8-9.5,11.8-14.5,17.4
        c-6.5,7.2-14.2,11.9-24.3,12.1c-20.2,0.5-40.4,1.3-60.6,2c-8.3,0.3-16.5,0.5-24.8,1c-13,0.8-25.9,1.7-38.9,3
        c-7.2,0.8-12.6,5.5-17.1,10.8c-11.9,14-23.6,28.2-35.4,42.3C133.6,287.6,122.9,300.6,111.5,314.3z"/>
      <path d="M373,186.4c2.7,10.5,5.4,20.3,7.8,30.2c3.1,12.6,6,25.3,9.2,38c3,12-0.5,22.3-8.2,31.5c-11.8,14.1-23.5,28.2-35.4,42.3
        c-7.7,9.2-15.6,18.2-23.3,27.4c-9.6,11.4-19,23-28.6,34.5c-7.9,9.4-16.3,18.5-24,28.2c-5.7,7.2-12.1,12.8-21.4,14.3
        c-1.6,0.3-3.2,0.6-4.9,0.6c-50.5,0-101,0-151.5,0.1c-14,0-28.3-13.5-30.1-27.5c-1.6-12.9,3.6-22.2,11.4-31.3
        c9.3-10.8,18.1-22,27.2-33c7.5-9,15.1-17.8,22.6-26.7c9.8-11.7,19.3-23.7,29.4-35.1c7.1-8,13-17.8,24.5-20.6
        c3.3-0.8,6.7-1.4,10.1-1.5c12.4-0.5,24.9-0.7,37.3-1.1c8.6-0.3,17.2-0.6,25.8-1c17-0.7,34.1-1.2,51.1-2c11.6-0.5,20.3-6.6,27.5-15.3
        c7.7-9.4,15.4-18.7,23.2-28.1C359.5,202.3,366,194.6,373,186.4z"/>
    </svg>
  );
};

export default SplaLogo;
